import React from 'react'

import { Modal, FormGroup, FormControl, ControlLabel } from 'react-bootstrap'

import Button from '../components/Button.jsx'
import {getText} from '../lib/text.js'


export default class AddProduct extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { name: "" }
  }

  render() {
    const { onClose, onCreate, type, city } = this.props

    return (
      <Modal show onHide={() => this.props.onClose()}>
        <Modal.Header>
          {getText(`Crear ${type}`)}
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <ControlLabel>
              {getText("Nombre en español")}
            </ControlLabel>
            <FormControl
              onChange={evt => this.setState({ name: evt.target.value })}
              value={this.state.name}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onClose()}>
            {getText("Cancelar")}
          </Button>
          <Button
            disabled={!this.state.name}
            bsStyle="success"
            onClick={() => this.state.name && onCreate(this.state.name, type, city)}
          >
            {getText("Crear")}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
